import axios from "./axios";
let href = ''
let host = window.location.host
// if (host.includes('dev')) {
//   href = 'http://dapi-dev.syncore.space:20080/'
// } else if (host.includes('test') || host.includes('localhost')) {
//   href = 'http://dapi-test.syncore.space:20080/'
// } else if (host.includes('pre')) {
//   href = 'http://dapi-pre.syncore.space:20080/'
// } else {
//   href = 'http://dapi.syncore.space/'
// }

if (host.includes('dev')) {
  href = 'https://api-data-dev.syncore.space:20443/xdatav-api/'
} else if (host.includes('test') || host.includes('localhost')) {
  href = 'https://api-data-test.syncore.space:20443/xdatav-api/'
} else if (host.includes('pre')) {
  href = 'https://api-data-pre.syncore.space:20443/xdatav-api/'
} else {
  href = 'https://api-data.syncore.space/xdatav-api/'
}

export const consultation = (data) => {
  return axios.post(`${href}api/stat/privacy/consultation`, data);
};

